<script setup lang="ts">
import { computed } from "vue";
import { FileType } from "@/types/file.types";
import { useQueryClient } from "@tanstack/vue-query";
import { QueryKey } from "@/stores/queries/query-keys";
import DRFilesUploaderDialog from "../UI/DRFilesUploaderDialog.vue";

const props = defineProps<{
  diagnosticId: number;
  projectId: number;
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const queryClient = useQueryClient();
const invalidateTemplates = () => {
  queryClient.invalidateQueries({ queryKey: [QueryKey.DIAGNOSTICS] });
};
const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    if (!value) {
      emit("update:modelValue", false);
    }
  },
});
</script>

<template>
  <DRFilesUploaderDialog
    v-model="show"
    :title="$t('report:import.report')"
    :helper="$t('report:import.report.project.one')"
    :file-type="FileType.DIAGNOSTIC_REPORT"
    :file-params="{
      diagnosticId: diagnosticId,
      projectId: projectId,
    }"
    :upload-description="() => $t('report:diagnostics.accept.pdf.docx')"
    :extensions="['pdf', 'docx']"
    :multiple="false"
    @uploaded="invalidateTemplates()"
  />
</template>
